export const protocolsProductTypes = {
  ELISA_KIT: 'ELISA Kit',
  ELISA_ANTIBODY_PAIR: 'ELISA Antibody Pair',
  FAST_SCAN_ELISA_KIT: 'FastScan ELISA Kit',
  OLIGO_ANTIBODY_PAIR: 'Oligo Antibody Pair',
  PTM_SCAN: 'PTMScan',
}
